import styled from 'styled-components'

const VersionsBox = styled.div`
  .-pointer:hover {
    color: #0047ff;
  }
  .table > :not(caption) > * > * {
    padding: 1rem 1.7rem;
  }
  .content-menu {
    width: 100%;
    padding-left: 256px;
  }
  .content-box {
    height: 100%;
  }
  .content-scroll {
    // margin-top: 100px;
    height: 87vh;
    overflow-y: auto;
  }
  .-pointer {
    cursor: pointer;
  }
  .btn {
    margin: 0.125em;
  }
  .boxSetting {
    right: 1%;
    width: 200px;
    text-align: left;
    border: 1px solid #0000000f;
    box-shadow: 6px 7px 20px 0 rgb(0 0 0 / 11%);
  }
  .dropdown-item-setting {
    cursor: pointer;
    padding: 10px;
  }
  .dropdown-item-setting:hover {
    background: #c1c1c129;
  }
  .badge {
    margin-left: 0px;
    min-width: 55px;
    text-align: center;
    font-size: 12px;
  }
  .badge-default {
    background-color: #f2f4f7;
    color: #344054;
  }
  .badge-green {
    background-color: #ecfdf3;
    color: #037a48;
  }
  .badge-blue {
    background-color: #0047ff;
    color: #fff;
  }
  .badge-yellow {
    background-color: #fec84b;
    color: #344054;
  }
  .badge-white {
    border: solid 1px #d0d5dd;
    background-color: #fff;
    color: #344054;
  }
  .table {
    svg {
      color: #98a2b3;
      cursor: pointer;
    }
  }

  .close:not(:disabled):not(.disabled) {
    cursor: pointer;
  }
  .alert-dismissible .close {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.75rem 1.25rem;
    color: inherit;
  }
  button.close {
    padding: 0;
    background-color: transparent;
    border: 0;
    -webkit-appearance: none;
  }
  .close {
    float: right;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: 0.5;
  }
  .alert-box {
    position: absolute;
    width: 30%;
    z-index: 999999;
    padding: 0px;
    top: 45px;
    right: 20px;
  }
  .input-group-text {
    padding: 10px 0.75rem;
    line-height: 1.5;
    background-color: #fff;
    display: flex;
    align-items: center;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border: 1px solid #ced4da;
    border-right: 0;
  }
  .boxsearch {
    right: 17%;
    width: 270px;
    text-align: left;
    border: 1px solid #0000000f;
    box-shadow: 6px 7px 20px 0 rgb(0 0 0 / 11%);
  }
`
const SubscriptionBox = styled.div`
  .flag-box {
    border: 1px solid #d0d5dd;
    padding: 3px 13px;
    border-radius: 5px;
    background: #f5f5f5;
  }
  .-flag {
    width: 25px;
  }
  .select-flag {
    font-size: 14px;
    font-weight: 600;
    color: #475467;
  }
  .foot-btn {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 100%;
  }

  .checkmark {
    display: inline-block;
    width: 20px;
    height: 19px;
    -ms-transform: rotate(45deg); /* IE 9 */
    -webkit-transform: rotate(45deg); /* Chrome, Safari, Opera */
    transform: rotate(45deg);
  }

  .checkmark_stem {
    position: absolute;
    width: 2px;
    height: 15px;
    background-color: #0047ff;
    left: 11px;
    top: 6px;
  }

  .checkmark_kick {
    position: absolute;
    width: 5px;
    height: 2px;
    background-color: #0047ff;
    left: 6px;
    top: 19px;
  }
  .badge {
    margin-left: 0px;
    min-width: 55px;
    text-align: left;
  }
  .badge-default {
    background-color: #f2f4f7;
    color: #344054;
  }
  .badge-green {
    background-color: #ecfdf3;
    color: #037a48;
  }
  .badge-blue {
    background-color: #0047ff;
    color: #fff;
  }
  .badge-yellow {
    background-color: #fec84b;
    color: #344054;
  }
  .badge-white {
    border: solid 1px #d0d5dd;
    background-color: #fff;
    color: #344054;
  }
  .badge-default {
    color: #ffffff;
    background-color: #96b3ff;
  }
  .badge-blue {
    color: #fff;
    background-color: #0047ff;
  }
  .badge-purple {
    color: #fff;
    background-color: #002fa8;
  }
  .badge-gray {
    color: #fff;
    background-color: #b9a884;
  }
  .badge-danger {
    color: #fff;
    background-color: #f04438;
  }
  .change-plan {
    position: absolute;
    left: calc(100% - 71%);
  }
  .space-between {
    justify-content: space-between;
  }
  #currency {
    padding: 4px;
    border: 1px solid #d0d5dd;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    border-radius: 8px;
  }
  .body-plan-box-bule {
    border-top: 5px solid #0d6efd;
    border-radius: 5px;
  }
  .body-plan-box-gray {
    // border-top: 5px solid #D0D5DD;
    border-radius: 5px;
  }
  .plan-box {
    cursor: pointer;
  }
  .plan-box:hover {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  }
  .plan-box-footer {
    text-align: center;

    color: #0047ff;
    height: 100px;
    position: relative;
    span {
      cursor: pointer;
    }
  }
  .slider-disabled:before {
    background-color: #ffffff !important;
  }
  .slider-disabled.round {
    background: #f5f5f5 !important;
    border: 1px solid #f5f5f5;
  }
  .slider-md:before {
    background-color: #ffffff !important;
  }
  .slider {
    background: #d0d5dd;
  }

  .table > :not(caption) > * > * {
    padding-left: 20px;
  }
  .content-menu {
    width: 100%;
    padding-left: 256px;
  }
  .content-box {
    height: 100%;
  }
  .content-scroll {
    // margin-top: 100px;
    height: 87vh;
    overflow-y: auto;
  }
  .-pointer {
    cursor: pointer;
  }

  .alert-box {
    position: absolute;
    width: 30%;
    z-index: 999999;
    padding: 0px;
    top: 45px;
    right: 20px;
  }

  .text-gray {
    color: #d0d5dd;
  }
  .text-green {
    color: #039855;
  }
  .text-blue {
    color: #6490fe;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 24px;
  }
  .slider:before {
    position: absolute;
    content: '';
    height: 15px;
    width: 15px;
    left: 4px;
    bottom: 4px;
    background-color: #0047ff;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  input:checked + .slider:before {
    -webkit-transform: translateX(15px);
    -ms-transform: translateX(15px);
    transform: translateX(15px);
    background-color: #fff;
  }

  .-input-credit {
    width: 384px;
    height: 40px;
    border: 1px solid #d0d5dd;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    border-radius: 8px;
    margin: 10px;
    padding: 8px 15px;
  }

  .-align-right {
    text-align: right;
  }
  .-float-right {
    float: right;
  }
  .alert-primary {
    --bs-alert-color: #ffffff;
    --bs-alert-bg: #0047ff;
    --bs-alert-border-color: #0047ff;
  }
`
const ModalToggle = styled.div`
  .slider {
    background: transparent;
  }
`
export { VersionsBox, SubscriptionBox, ModalToggle }
